module.exports = __webpack_public_path__ + "media/images/scoreBet__scoreUp--inactive-af2926cea26ca6465971df34e9977367.png";